import React from 'react'
import ReactDOM from 'react-dom'
import { imagePath } from 'shared/images'

const Error = ({ size = 'lg' }) => {
  const { yMargin, imgSize, titleMargin } = {
    lg: {
      yMargin: 100,
      imgSize: 250,
      titleMargin: 30,
    },
    sm: {
      yMargin: 20,
      imgSize: 150,
      titleMargin: 10,
    },
  }[size]
  return (
    <div
      className={`text-center top-${yMargin} bottom-${yMargin} d-flex flex-column align-items-center`}
    >
      <img
        src={imagePath('error.svg')}
        style={{ width: imgSize, height: imgSize }}
      />
      <h2 className={`top-${titleMargin + 10} bottom-${titleMargin}`}>
        {I18n.t('js.pro.error')}
      </h2>
      <p>{I18n.t('js.pro.error_text')}</p>
    </div>
  )
}

export default Error
